import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=727ba9b7&scoped=true&"
import script from "./js/approver.js?vue&type=script&lang=js&"
export * from "./js/approver.js?vue&type=script&lang=js&"
import style0 from "./approver.vue?vue&type=style&index=0&id=727ba9b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ba9b7",
  null
  
)

export default component.exports